<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-2">


    <!-- Header -->
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">

        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="exit()" type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex items-center gap-x-2">
                    <h3 class="text-md font-semibold text-primary">Smart Brief Create
                    </h3>
                    @if (showDraftSaved()) {
                    <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium text-secondary">Draft saved</span>
                    }
                    <!-- <span
          class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset">Text</span> -->
                </div>
                <p class="mt-0 text-xs text-secondary">Let's build a brief together</p>
                @if (draftNotice()) {
                <p class="mt-1 text-xs text-secondary">{{ draftNotice() }}</p>
                }
            </div>
        </div>

        <div class="flex flex-row items-center justify-end gap-x-4">
            <button type="button" (click)="createBrief()" [disabled]="!createReady()"
                class="btn-shout btn-shout-sm btn-shout-primary shrink-0">{{ createActionLabel() }}</button>
            <button type="button" (click)="startOver()"
                class="btn-shout btn-shout-sm btn-shout-secondary shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5" aria-hidden="true">
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                    <path d="M3 3v5h5" />
                </svg>
                Start over
            </button>
        </div>

    </div>
    <!-- Header - END-->

    <!-- Main Section -->

    <div class="h-full w-full flex flex-col justify-start items-center overflow-hidden w-full">
        <div class="w-full h-full grid grid-cols-4 gap-2">
            <!-- Chat Content -->
            <div class="col-span-3 h-full overflow-hidden flex flex-col gap-y-2 rounded-xl border border-border p-2 textured-background ">
                <div class="w-full flex-1 overflow-hidden">
                    <div #thread class="h-full overflow-y-auto" role="log" aria-live="polite">
                        <div class="mx-auto max-w-7xl px-6 sm:px-12">
                        <div class="sb-col">
                            @if (showOpeningTyping() && !conversation().draft.briefType) {
                            <ng-container [ngTemplateOutlet]="typing" />
                            }
                            @for (message of openingMessages(); track message.kind) {
                            @switch (message.kind) {
                            @case ('greeting') {
                            <div class="sb-msg ai">
                                <ng-container [ngTemplateOutlet]="avatar" />
                                <div class="sb-m-body">
                                    <p>
                                        @if (message.name) {
                                        <b>Hi {{ message.name }}.</b>
                                        } @else {
                                        Hi.
                                        }
                                        {{ message.rest }}
                                    </p>
                                </div>
                            </div>
                            }
                            @case ('choice') {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ message.text }}</div>
                            </div>
                            }
                            @case ('follow-up') {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: message.text }" />
                            }
                            }
                            }
                            @if (showOpeningTyping() && conversation().draft.briefType) {
                            <ng-container [ngTemplateOutlet]="typing" />
                            }

                            @if (conversation().draft.briefType; as briefType) {
                            @for (reply of conversation().helpReplies; track $index) {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: helpQuestion(briefType, $index) }" />
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ reply }}</div>
                            </div>
                            }
                            @if (currentQuestion(); as question) {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: question }" />
                            }
                            @if (sentText() && conversation().draft.source !== 'Written with AI help') {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ sentText() }}</div>
                            </div>
                            }
                            @if (showProductQuestion()) {
                            <ng-container [ngTemplateOutlet]="productQuestion" />
                            }
                            @if (firstProductCard(); as product) {
                            <ng-container [ngTemplateOutlet]="productCard" [ngTemplateOutletContext]="{ product: product }" />
                            }
                            @if (conversation().step === 'dos' || conversation().copyReplies.dos) {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'What are the mandatory items?' }" />
                            }
                            @if (conversation().copyReplies.dos) {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ conversation().copyReplies.dos }}</div>
                            </div>
                            }
                            @if (conversation().step === 'donts' || conversation().copyReplies.donts) {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'What are the restrictions?' }" />
                            }
                            @if (conversation().copyReplies.donts) {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ conversation().copyReplies.donts }}</div>
                            </div>
                            }
                            @for (item of answered(); track item.question) {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: item.question }" />
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ item.answer }}</div>
                            </div>
                            }
                            @if (conversation().step !== 'lookback' && conversation().step !== 'window' && conversation().step !== 'dos' && conversation().step !== 'donts' && activeQuestion(); as activeQuestion) {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: activeQuestion }" />
                            }
                            @if (conversation().step === 'pieces') {
                            <bb-content-section />
                            <button type="button" (click)="confirmCurrentPieces()"
                                class="btn-shout btn-shout-sm btn-shout-primary shrink-0 self-start">Pieces look good</button>
                            }
                            @if (conversation().step === 'creators') {
                            <div class="flex flex-wrap gap-2">
                                @for (count of creatorOptions; track count) {
                                <button type="button" (click)="pickCreatorCount(count)"
                                    class="btn-shout btn-shout-sm btn-shout-secondary shrink-0">{{ creatorCountLabel(count) }}</button>
                                }
                            </div>
                            }
                            @if (conversation().step === 'audience' && !conversation().draft.audience) {
                            <bb-audience-section />
                            <button type="button" (click)="confirmCurrentAudience()"
                                class="btn-shout btn-shout-sm btn-shout-primary shrink-0 self-start">Audience looks good</button>
                            }
                            @if (conversation().step === 'lookback') {
                            <div class="rounded-xl border border-border bg-card p-4">
                                <sbs-screening-window (confirmed)="confirmScreeningRange($event)" />
                            </div>
                            }
                            @if (conversation().step === 'window') {
                            <div class="rounded-xl border border-border bg-card p-4">
                                <cmb-monitoring-window (confirmed)="confirmMonitoringRange($event)" />
                            </div>
                            }
                            @if (lookbackLabel()) {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ lookbackLabel() }}</div>
                            </div>
                            }
                            @if (conversation().step !== 'window' && windowLabel()) {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ windowLabel() }}</div>
                            </div>
                            }
                            @if (conversation().step === 'report' && !conversation().draft.reportType) {
                            <div class="flex flex-wrap gap-2">
                                <button type="button" (click)="pickReport('standard')"
                                    class="btn-shout btn-shout-sm btn-shout-secondary shrink-0">Standard report</button>
                                <button type="button" (click)="pickReport('custom')"
                                    class="btn-shout btn-shout-sm btn-shout-secondary shrink-0">Custom report</button>
                            </div>
                            }
                            @if (conversation().draft.reportType === 'standard') {
                            <div class="sb-msg user">
                                <div class="sb-bubble">Standard report</div>
                            </div>
                            }
                            @if (conversation().draft.reportPrompt) {
                            <div class="sb-msg user">
                                <div class="sb-bubble">{{ conversation().draft.reportPrompt }}</div>
                            </div>
                            }
                            @if (conversation().step === 'review') {
                            <button type="button" (click)="acceptBrief()"
                                class="btn-shout btn-shout-sm btn-shout-primary shrink-0 self-start">Looks good</button>
                            }
                            @if (conversation().step === 'ready' && conversation().draft.briefType === 'ugc') {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'Publish this brief from the panel so creators can apply.' }" />
                            } @else if (conversation().step === 'ready' && conversation().draft.briefType === 'screening') {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'Create this screening brief.' }" />
                            <button type="button" (click)="createBrief()" [disabled]="!createReady()"
                                class="btn-shout btn-shout-md btn-shout-primary shrink-0 self-start">{{ createActionLabel() }}</button>
                            } @else if (conversation().step === 'ready' && conversation().draft.briefType === 'monitoring') {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'Create this monitoring brief.' }" />
                            <button type="button" (click)="createBrief()" [disabled]="!createReady()"
                                class="btn-shout btn-shout-md btn-shout-primary shrink-0 self-start">{{ createActionLabel() }}</button>
                            } @else if (conversation().step === 'ready') {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'Ready to create.' }" />
                            }
                            @for (product of laterProductCards(); track $index) {
                            <ng-container [ngTemplateOutlet]="productQuestion" />
                            <ng-container [ngTemplateOutlet]="productCard" [ngTemplateOutletContext]="{ product: product }" />
                            }
                            @if (showFreshProductQuestion()) {
                            <ng-container [ngTemplateOutlet]="productQuestion" />
                            }
                            @if (readState() === 'reading' && !showOpeningTyping()) {
                            <ng-container [ngTemplateOutlet]="typing" />
                            }
                            @if (readState() === 'error') {
                            <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: readError() }" />
                            }
                            }

                            <ng-template #avatar>
                                <div class="sb-av" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                                        <path d="M20 2v4" />
                                        <path d="M22 4h-4" />
                                        <circle cx="4" cy="20" r="2" />
                                    </svg>
                                </div>
                            </ng-template>
                            <ng-template #typing>
                                <div class="sb-msg ai" aria-label="Assistant is typing">
                                    <ng-container [ngTemplateOutlet]="avatar" />
                                    <div class="sb-m-body">
                                        <div class="sb-typing" aria-hidden="true"><span></span><span></span><span></span></div>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #productQuestion>
                                <ng-container [ngTemplateOutlet]="assistant" [ngTemplateOutletContext]="{ text: 'Which product is this for?' }" />
                            </ng-template>
                            <ng-template #productCard let-product="product">
                            <div class="sb-msg user">
                                <div class="sb-product-sent">
                                    <span class="sb-product-sent-thumb" aria-hidden="true">
                                        @if (product.image) {
                                        <img [src]="productImageUrl(product.image)" alt="" />
                                        } @else {
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                                            <circle cx="9" cy="9" r="2" />
                                            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                                        </svg>
                                        }
                                    </span>
                                    <span class="sb-product-sent-tx">
                                        <span class="sb-product-sent-t">{{ product.name }}</span>
                                        @if (product.description) {
                                        <span class="sb-product-sent-d">{{ product.description }}</span>
                                        }
                                    </span>
                                    @if (productPrice(product)) {
                                    <span class="sb-product-sent-price">{{ productPrice(product) }}</span>
                                    }
                                </div>
                            </div>
                            </ng-template>
                            <ng-template #assistant let-text="text">
                                <div class="sb-msg ai">
                                    <ng-container [ngTemplateOutlet]="avatar" />
                                    <div class="sb-m-body">
                                        <p>{{ text }}</p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- User Input Section -->
                <div class="shrink-0 w-full flex-col space-y-4 bg-card rounded-xl pt-2" (dragover)="onBriefDragOver($event)"
                    (drop)="onBriefDrop($event)">

                    @if (conversation().step === 'intro' && greetingReady()) {
                    <div class="w-full flex px-4">
                        <cbss-brief-type class="w-full" (chosen)="onBriefType($event)" />
                    </div>
                    } @else if (conversation().step === 'supply') {
                    <div class="w-full px-4">
                        <cbss-add-brief class="w-full" (chosen)="chooseSupply($event)" />
                    </div>
                    } @else if (conversation().step === 'review') {
                    <p class="px-4 text-sm text-secondary">Or describe a change.</p>
                    } @else if (conversation().step === 'product' && !conversation().draft.productId) {
                    <div class="w-full flex px-4">
                        <cbss-product class="w-full" [createOnOpen]="productCreate()" (chosen)="onProduct($event)" (createClosed)="closeProductCreate()" />
                    </div>
                    }

                    <!-- Chat Input -->
                    <div
                        class="w-full flex flex-row items-center justify-between gap-x-4 rounded-xl border border-border bg-card px-4 focus-within:border-ring focus-within:ring-2 focus-within:ring-ring/30">
                        <div class="shrink-0">
                            <input #briefFile type="file" class="sr-only" accept=".pdf,.docx,.txt,application/pdf,text/plain"
                                aria-label="Upload a brief" (change)="onBriefFile($event)" />
                            <button type="button" class="btn-fab-transparent" aria-label="Attach a file"
                                (click)="openBriefFile(briefFile)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path
                                        d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551" />
                                </svg>
                            </button>
                        </div>

                        <div class="flex-1 py-1">
                            <textarea #briefComposer id="comment" name="comment" rows="2" aria-label="Brief"
                                [value]="draftText()" [attr.placeholder]="composerPlaceholder()" (input)="onDraftInput($event)"
                                class="input-textarea-transparent resize-none"></textarea>
                        </div>

                        <div class="shrink-0">
                            <button type="button" (click)="sendTypedBrief()" [disabled]="!canSend()"
                                class="btn-shout btn-shout-fab-primary shrink-0" aria-label="Send brief">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path d="m5 12 7-7 7 7" />
                                    <path d="M12 19V5" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    @if (holdMessage()) {
                    <p class="px-4 text-sm text-secondary">{{ holdMessage() }}</p>
                    }
                    <!-- Chat Input - END -->

                </div>
                <!-- User Input Section - END -->
            </div>
            <!-- Chat Content - END -->

            <!-- Right Hand Sidebar - Stepper -->
            <div class="col-span-1 h-full overflow-hidden rounded-xl border border-border bg-card">
                <cbss-live-brief class="block h-full min-h-0" [briefType]="conversation().draft.briefType" [step]="conversation().step"
                    [draft]="conversation().draft" [savedCampaignId]="savedCampaignId()"
                    [savedPricingModelId]="savedPricingModelId()" [canPublish]="createReady()"
                    [askedDos]="conversation().copyReplies.dos.length > 0" [askedDonts]="conversation().copyReplies.donts.length > 0"
                    (editPieces)="revisitPieces()" (changeProduct)="revisitProduct()" (addProduct)="revisitNewProduct()"
                    (publish)="createBrief()" />
            </div>
            <!-- Right Hand Sidebar - Stepper - END -->
        </div>
    </div>

    <!-- Main Section - END -->

</div>